function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import moment from 'moment';
import CustomerLocaleKeys from './../../../../../locales/keys';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CurrentLockerItemIdSelector } from '../../../../../reducers/selectors/customer.product.detail.selectors';
import { ActiveProductSelector } from '../../../../../reducers/selectors/customer.products.selectors';
import { grantAdditionalRights } from '../../../../../reducers/actions/customer.product.detail.actions';
var MAX_NUMBER_OF_OPTIONS = 7;
var GrantAccessRightsController = /*#__PURE__*/function () {
  function GrantAccessRightsController($ngRedux) {
    _classCallCheck(this, GrantAccessRightsController);
    Object.assign(this, {
      CustomerLocaleKeys: CustomerLocaleKeys,
      $ngRedux: $ngRedux
    });
  }
  return _createClass(GrantAccessRightsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeProduct: ActiveProductSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentLockerItemId: CurrentLockerItemIdSelector(store)
        };
      };
      var controllerActions = {
        grantAdditionalRights: grantAdditionalRights
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.options = Array.from(new Array(MAX_NUMBER_OF_OPTIONS), function (i, index) {
        return index + 1;
      });
      if (this.policyCollection) {
        this.policyCollection = this.policyCollection.filter(function (item) {
          return item.AccessRequestsRemaining || item.LicenseRequestsRemaining || item.ExpirationDate;
        }).asMutable({
          deep: true
        });
      }
      this.hoursPattern = /^\d+$/;
      this.model = {
        Id: this.state.currentLockerItemId || this.state.activeProduct.Id,
        ActionCode: null,
        GrantAccessCount: null,
        GrantLicenseCount: null,
        GrantTimeRemaining: null
      };
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this2 = this;
      this.model.ActionCode = this.policy.ActionCode;
      if (this.GrantAccessForm.$valid) {
        return this.actions.grantAdditionalRights(this.state.currentCustomerId, this.model).then(function () {
          _this2.onSuccess()();
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getSelectDisplayText",
    value: function getSelectDisplayText(value) {
      return value ? i18n.translate(this.CustomerLocaleKeys.SELECT) : i18n.translate(this.CustomerLocaleKeys.GRANT_ACCESS.NOT_AVAILABLE);
    }
  }, {
    key: "getDialogSize",
    value: function getDialogSize() {
      return this.policyCollection ? 'medium' : 'small';
    }
  }, {
    key: "displayZeroWhenEmpty",
    value: function displayZeroWhenEmpty(property) {
      return property || i18n.translate(this.CustomerLocaleKeys.PRODUCTS_PAGE.ZERO);
    }
  }, {
    key: "calculateTimeRemaining",
    value: function calculateTimeRemaining(expirationDate) {
      if (expirationDate) {
        this.isExpired = moment(expirationDate).isBefore(moment());
        var difference = moment(expirationDate).diff(moment());
        var duration = difference > 0 ? moment.duration(difference) : moment.duration(moment());
        return i18n.translate(this.CustomerLocaleKeys.PRODUCTS_PAGE.TIME_REMAINING_DISPLAY, {
          Day: duration.days(),
          Hour: duration.hours(),
          Minute: duration.minutes()
        });
      } else {
        return null;
      }
    }
  }]);
}();
export default {
  template: require('./grant.access.rights.popup.html'),
  controller: GrantAccessRightsController,
  controllerAs: 'GrantAccessRights',
  bindings: {
    policy: '<',
    policyCollection: '<',
    onClose: '&',
    onSuccess: '&'
  }
};